import script from "./NoInternetModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./NoInternetModal.vue?vue&type=script&setup=true&lang=ts"

import "./NoInternetModal.vue?vue&type=style&index=0&id=08b7bbbe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08b7bbbe"]])

export default __exports__